// extracted by mini-css-extract-plugin
module.exports = {"icon":"SearchIcon_icon__23POl"};